export default {
  namespaced: true,
  state: {
    stuCourseData: {
      created_at: '',
      deleted_at: '',
      faculty_id: '',
      grades: '',
      id: '',
      level: '',
      name: '',
      updated_at: '',
    },
  },
  mutations: {
    saveStuCourseData(state, payload) {
      state.stuCourseData = {...payload}
    },
  },
  actions: {},
}
